// Autogenerated file
export const documentAssignmentStatusesEnum = {
    Created: "Created",
    DocumentsUploaded: "DocumentsUploaded",
    DocumentsRejected: "DocumentsRejected",
    DocumentsApproved: "DocumentsApproved",
    EnvelopeScanned: "EnvelopeScanned",
    PostamatScanned: "PostamatScanned",
    Completed: "Completed",
    ClosedAutomatically: "ClosedAutomatically",
};
export const documentAssignmentStatuses = [
    { label: "Задача создана", value: "Created" },
    { label: "Документы загружены", value: "DocumentsUploaded" },
    { label: "Документы отклонены", value: "DocumentsRejected" },
    { label: "Документы утверждены", value: "DocumentsApproved" },
    { label: "Конверт отсканирован", value: "EnvelopeScanned" },
    { label: "Постамат отсканирован", value: "PostamatScanned" },
    { label: "Задача завершена", value: "Completed" },
    { label: "Закрыто автоматически", value: "ClosedAutomatically" },
];
